import React, { useEffect } from "react";

const PORTRAIT_SRC = "/assets/hi3ris-portrait.png";
const HERO_SRC = "/assets/hi3ris-hero.jpg";

export function ManifestoPortrait({ caption = "HI3RIS" }) {
  return (
    <figure className="mp-dossier" aria-label={"Portrait of " + caption}>
      <div className="mp-dossier-tab">
        <span>HI3RIS</span><span>· 0x02 ·</span>
      </div>
      <div className="mp-dossier-body">
        <div className="mp-dossier-stamp">CONFIDENTIAL</div>
        <div className="mp-dossier-stamp mp-dossier-stamp-2">2026 / TG</div>
        <div className="mp-dossier-grid" />
        <img className="mp-dossier-img" src={PORTRAIT_SRC}
             alt={"Portrait — " + caption} loading="lazy" />
        <div className="mp-dossier-meta">
          <div><span>NAME</span><b>RAMSÈS J. DAGBAN</b></div>
          <div><span>BASE</span><b>LOMÉ · TG</b></div>
          <div><span>ROLE</span><b>L2 SOC · PENTEST</b></div>
          <div><span>SIGN</span><i>~ hi3ris</i></div>
        </div>
      </div>
    </figure>
  );
}

export function HeroPhoto({ parallax = false }) {
  useEffect(() => {
    if (!parallax) return;
    const el = document.querySelector(".hero-photo-img");
    if (!el) return;
    const onScroll = () => {
      el.style.transform = "translateY(" + (window.scrollY * 0.18) + "px)";
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [parallax]);
  return (
    <div className="hero-photo hero-photo-ghost" aria-hidden="true">
      <div className="hero-photo-img" style={{ backgroundImage: `url('${HERO_SRC}')` }} />
      <div className="hero-photo-tint" />
      <div className="hero-photo-grain" />
    </div>
  );
}
